import * as actionType from "../constants";

export const clearAllAttachment =
  (any = null) =>
  (dispatch) => {
    if (any === "status") {
      return;
    }
    dispatch({ type: actionType.CLEAR_ALL_IMAGE });
  };
